<div class="videoContainer">
	<div class="twinViewContainer">
		<div class="left aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="0" />
		</div>
		<div class="right aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="1" />
		</div>
	</div>
</div>
